import { useState, useEffect, useRef } from "react";
import IC_VIDEO from "@/assets/video/ic_video.svg?react";
import IC_EXPORT_VIDEO from "@/assets/video/ic_export_video.svg?react";
import videoPlayerStore from "@/store/videoPlayer.store";

import BG_TIPS_BODY from "@/assets/video/bg_tips_body.png";
import BG_TV from "@/assets/video/bg_tv.svg?react";
import summaryCommonStore from "@/store/summaryCommon.store";
import { useShallow } from "zustand/react/shallow";
import lottie from "lottie-web";
import data from "@/assets/audio_play.json";

interface VideoEnterProps {
  isPlaying: boolean;
  openCb: () => void
}

function VideoEnter(prop: VideoEnterProps) {
  const key = 'videoTipShowed';
  const ref = useRef<HTMLDivElement>(null);

  const [showHoverExport, setShowHoverExport] = useState(false);
  const [visible, setVisible] = useState(false);

  const lottieRef = useRef(null);

  const { audioInfo } = summaryCommonStore(
    useShallow((state) => ({
      audioInfo: state.audioInfo
    }))
  );

  useEffect(() => {
    const isShow = localStorage.getItem(key);
    if (isShow === null || isShow !== "true") {
      setVisible(true);
    }
    setTimeout(() => {
      document.addEventListener("click", handleClickOutside);
    }, 100);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    console.log('prop.isPlaying', prop.isPlaying);
    lottie.destroy();
    if (prop.isPlaying) {
      lottie.loadAnimation({
        container: lottieRef.current!,
        loop: true,
        autoplay: true,
        renderer: "svg",
        animationData: data,
      });
    }

    return () => {
      lottie.destroy();
    }
  }, [prop.isPlaying]);

  const handleClickOutside = (event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      setVisible(false);
      localStorage.setItem(key, "true");
    }
  };

  const videoPlayHandle = () => {
    prop.openCb();
    setVisible(false);
    localStorage.setItem(key, "true");
    videoPlayerStore.getState().changeType("fullScreen");
  };

  return (
    <div ref={ref} className="relative">
      <div className='w-18 h-10 mr-3 rd-1 bg-mx-secondary flex items-center justify-center bg-contain bg-no-repeat cursor-pointer relative'
        style={{ backgroundImage: audioInfo?.coverUrl && `url(${audioInfo?.coverUrl})` }}
        onClick={videoPlayHandle}
        onMouseEnter={() => { setShowHoverExport(true) }}
        onMouseLeave={() => { setShowHoverExport(false) }}
      >
        {(prop.isPlaying || !showHoverExport) &&
          <div className="w-8 h-8 relative flex justify-center z-1">
            <BG_TV className="absolute top-0 left-0 w-8 h-8" />
            {prop.isPlaying ? < div ref={lottieRef} className="h-4.2 mt-1.5" /> : <IC_VIDEO className="w-2.6 mt-2 ml-0.25" />}
          </div>
        }

        {!prop.isPlaying && showHoverExport && <IC_EXPORT_VIDEO className="w-8 h-8 z-1" />}
        <div className="absolute w-18 h-10 rd-1 top-0 left-0 bg-#00000080"></div>
      </div>
      {
        visible && (
          <div className="absolute w-68 h-36.5 z-99 flex flex-col px-4 pt-3 px-5 bottom-10 left-0 rd-1.5 bg-no-repeat bg-contain"
            style={{ backgroundImage: `url(${BG_TIPS_BODY})` }}>
            <span className="text-size-4 text-#4981F2 font-bold mb-2">查看视频</span>
            <span className="text-size-3 text-#30343C lh-5.5 mb-2">点这里可以查看视频哦，小窗播放模式支持同时查看视频和原文总结</span>
            <button
              className='self-end w-22 h-8 rd-1.5 px-4 text-white text-size-3.5 hover:opacity-90 outline-none border-none cursor-pointer bg-mx-primary'
              onClick={(e) => {
                e.stopPropagation();
                setVisible(false);
                localStorage.setItem(key, "true");
              }}
            >我知道了</button>
          </div>
        )
      }
    </div >
  );
}

export default VideoEnter;
